<!--
 * @Author: Gaho
 * @Date: 2024-04-05 10:18:40
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-26 14:32:04
 * @Description: 
-->
<template>
    <Board 
        :isAnimate="false"
        class="corgiwild-board-popup no-animation"
        :showBg="false"
        :resResult="history"
    />
</template>

<script lang="ts" setup>
import Board from '@/pages/casino/corgiwildGame/_components/board/index.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    }
})
</script>

<style lang="scss" scoped>
.corgiwild-board-popup {
    :deep(.corgiwild-wrapper-break) {
        height: 250px !important;
    }
    .card-bg {
        bottom: 5px;
        left: 5px;
        right: 5px;
        top: 5px;
        &::before {
            height: 63px;
            width: 63px
        }
    }
    .card-bg-img {
        max-height: 90%
    }
}
</style>